/**
 * CAP-1 — UX Admin capacité créneau (héritage vs override).
 * null ≠ 1 : override explicite 1 reste représentable.
 */

export const CAPACITE_MODE = {
  HERITE: 'HERITE',
  OVERRIDE: 'OVERRIDE',
};

/**
 * @param {number|null|undefined} capacite
 * @returns {'HERITE'|'OVERRIDE'}
 */
export function resolveCapaciteModeFromStored(capacite) {
  return capacite == null ? CAPACITE_MODE.HERITE : CAPACITE_MODE.OVERRIDE;
}

/**
 * Payload capacite pour API (null = héritage).
 * @param {{ mode: string, overrideValue?: unknown }} params
 * @returns {number|null}
 */
export function buildCreneauCapacitePayload({ mode, overrideValue }) {
  if (mode !== CAPACITE_MODE.OVERRIDE) {
    return null;
  }
  const n = Number(overrideValue);
  if (!Number.isInteger(n) || n < 1) {
    throw new Error('CAPACITE_INVALIDE');
  }
  return n;
}

/**
 * Label liste créneaux.
 * @param {number|null|undefined} capacite
 * @param {number|null|undefined} maxParticipants
 * @returns {string}
 */
export function formatCreneauCapaciteListLabel(capacite, maxParticipants) {
  if (capacite == null) {
    const max = Math.max(1, Number(maxParticipants) || 1);
    return `Hérite (${max} pers.)`;
  }
  return `${capacite} pers.`;
}

/**
 * État formulaire depuis un créneau stocké.
 * @param {{ capacite?: number|null }|null|undefined} creneau
 * @param {number|null|undefined} maxParticipants
 */
export function creneauFormCapaciteFromStored(creneau, maxParticipants) {
  const stored = creneau?.capacite;
  if (stored == null) {
    return {
      mode: CAPACITE_MODE.HERITE,
      overrideValue: Math.max(1, Number(maxParticipants) || 1),
    };
  }
  return {
    mode: CAPACITE_MODE.OVERRIDE,
    overrideValue: stored,
  };
}

/**
 * Défaut création : héritage.
 * @param {number|null|undefined} maxParticipants
 */
export function defaultCreneauFormCapacite(maxParticipants) {
  return {
    mode: CAPACITE_MODE.HERITE,
    overrideValue: Math.max(1, Number(maxParticipants) || 1),
  };
}
